import { createRoot } from 'react-dom/client';
import React from 'react';
import './styles.css';
import App from './App';

const rootElement = document.getElementById('root');

if (rootElement) {
  // createRoot yordamida rendering
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}